var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyst1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M778.24 204.8h40.96v491.52h-40.96zM204.8 778.24h491.52v40.96H204.8zM286.72 532.48h40.96v204.8H286.72zM409.6 409.6h40.96v327.68h-40.96zM532.48 286.72h40.96v163.84h-40.96zM655.36 204.8h40.96v245.76h-40.96zM614.4 737.28a122.88 122.88 0 1 1 122.88-122.88 122.88 122.88 0 0 1-122.88 122.88z m0-204.8a81.92 81.92 0 1 0 81.92 81.92 81.92 81.92 0 0 0-81.92-81.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M661.21728 690.33984l28.95872-28.95872 122.79808 122.83904-28.95872 28.95872z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyst1);
export default __webpack_public_path__ + "static/media/analyst-1.0787b4cd3b58115dfd9d450c741edad4.svg";
export { ForwardRef as ReactComponent };